// We're getting a bunch of html from the server and shoving it into react here.

import * as React from 'react';

import {Api} from 'nutshell-core/api';

import {AppErrorHandler} from '../errors/app-error-handler';

import {ReportFeatureGatePageWrapper} from './leads-reports/report-feature-gate-page-wrapper';

import styles from './report-analytics-page.module.css';
import 'less/quickreport.less';

type State = {
    serverMarkup: string | null | undefined;
    didRenderServerMarkup: boolean;
};

const viewApi = new Api('/');
const headers = new Headers({
    'Content-Type': 'application/xhtml+xml',
    accept: '*/*',
    'X-Requested-With': 'XMLHttpRequest',
});

export class ReportAnalyticsPage extends React.Component<Record<any, any>, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            serverMarkup: null,
            didRenderServerMarkup: false,
        };
    }

    componentDidMount() {
        this.fetchNewMarkup();
    }

    componentDidUpdate(prevProps: Record<any, any>, prevState: State) {
        if (
            prevState.serverMarkup !== this.state.serverMarkup ||
            prevState.didRenderServerMarkup !== this.state.didRenderServerMarkup
        ) {
            if (this.state.didRenderServerMarkup) {
                // mountAnalyticsSidebar();

                Nut.updateAppearances();
                Nut.preparePage();
            }
        }
    }

    render() {
        return (
            <>
                {NutClientConfig.hasOnDemandReporting ? (
                    <AppErrorHandler>
                        {this.state.serverMarkup ? (
                            <div
                                ref={(ref) => {
                                    if (ref && !this.state.didRenderServerMarkup) {
                                        this.setState({didRenderServerMarkup: true});
                                    }
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: this.state.serverMarkup,
                                }}
                                className={styles['report-analytics-page']}
                            />
                        ) : null}
                    </AppErrorHandler>
                ) : (
                    <ReportFeatureGatePageWrapper reportKey='snapshots' />
                )}
            </>
        );
    }

    fetchNewMarkup = () => {
        this.setState({
            serverMarkup: null,
        });

        viewApi
            // @ts-expect-error
            .get(`/report-analytics.webchunk`, undefined, headers)
            .then((res) => {
                // @ts-expect-error
                if (res.redirected) {
                    // @ts-expect-error
                    window.location = res.url;
                }

                return res;
            })
            // @ts-expect-error
            .then((res) => res.text())
            .then((body) => {
                this.setState({
                    serverMarkup: body,
                });
            })
            .catch(() => {
                // TODO: Handle error
            });
    };
}
